import axios from "axios";
import { Message } from "element-ui";
import { API_BASE } from "./config";
import adminStore from "../store/admin";

function showRequestError(message) {
  Message({
    type: "error",
    message: message || "接口请求失败",
    showClose: true,
    duration: 3000
  });
}

function normalizeError(message, response, config) {
  const normalizedError = new Error(message || "接口请求失败");
  normalizedError.response = response;
  normalizedError.config = config;
  return normalizedError;
}

let authExpiredHandling = false;
function isAuthFailure(response) {
  return Boolean(response && (response.status === 401 || (response.data && response.data.code === 401)));
}
function handleAuthExpired() {
  window.localStorage.removeItem("admin_token");
  adminStore.clear();
  if (authExpiredHandling) return;
  authExpiredHandling = true;
  Message({ type: "warning", message: "登录已过期，请重新登录", showClose: true, duration: 3000 });
  const hash = window.location.hash.replace(/^#/, "") || "/";
  if (!hash.startsWith("/login")) window.location.hash = `#/login?redirect=${encodeURIComponent(hash)}`;
  window.setTimeout(() => { authExpiredHandling = false; }, 1500);
}

const http = axios.create({
  baseURL: API_BASE,
  timeout: 15000
});

http.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (response) => {
    const payload = response.data;
    if (payload && typeof payload === "object" && payload.code !== undefined && payload.code !== 0) {
      if (isAuthFailure(response)) {
        handleAuthExpired();
        const authError = normalizeError(payload.message || "登录已过期", response, response.config);
        authError.__toastShown = true;
        return Promise.reject(authError);
      }
      const message = payload.message || "接口请求失败";
      const normalizedError = normalizeError(message, response, response.config);
      if (response.config.showErrorMessage !== false) {
        showRequestError(message);
        normalizedError.__toastShown = true;
      }
      return Promise.reject(normalizedError);
    }
    return payload;
  },
  (error) => {
    const message = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : "接口请求失败";
    const normalizedError = normalizeError(message, error.response, error.config);
    if (isAuthFailure(error.response) && !(error.config && /\/auth\/login/.test(error.config.url || ""))) {
      handleAuthExpired();
      normalizedError.__toastShown = true;
      return Promise.reject(normalizedError);
    }
    if (!error.config || error.config.showErrorMessage !== false) {
      showRequestError(message);
      normalizedError.__toastShown = true;
    }
    return Promise.reject(normalizedError);
  }
);

export default http;
